"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalMiddleWare = exports.eventsMiddleWare = void 0;
var __1 = require("../..");
var logger_1 = require("../../logger");
var actionMapper_1 = require("./actionMapper");
var internalStore = undefined, externalStore = undefined;
var configureStores = function (apiStore) {
    if (!internalStore) {
        internalStore = __1.store;
        logger_1.Log.debug('SETTING INTERNAL STORE TO: ', internalStore);
    }
    if (!externalStore) {
        externalStore = apiStore;
        logger_1.Log.debug('SETTING EXTERNAL STORE TO: ', externalStore);
    }
};
var eventsMiddleWare = function (api) {
    return function (next) {
        return function (action) {
            configureStores(api);
            var externalActionType = action.type;
            var newInternalAction = actionMapper_1.externalToInternalTypeMap[externalActionType];
            logger_1.Log.debug('EXTERNAL ACTION TYPE IS: ', externalActionType);
            if (newInternalAction) {
                internalStore.dispatch(newInternalAction(action));
            }
            next(action);
        };
    };
};
exports.eventsMiddleWare = eventsMiddleWare;
var internalMiddleWare = function (api) {
    return function (next) {
        return function (action) {
            var internalActionType = action.type;
            var newExternalAction = actionMapper_1.internalToExternalTypeMap[internalActionType];
            logger_1.Log.debug('INTERNAL ACTION TYPE IS: ', internalActionType);
            /**
             * In the event of integration tests, the middleware will not have
             * an external store
             */
            if (newExternalAction && externalStore) {
                externalStore.dispatch(newExternalAction(action));
            }
            next(action);
        };
    };
};
exports.internalMiddleWare = internalMiddleWare;
//# sourceMappingURL=eventsMiddleWare.js.map